<template>
    <div class="p-sm gap-md card flex h-64 flex-col rounded-md border border-(--border-subtle)">
        <div class="flex justify-between">
            <h1>{{ name }}</h1>
            <TagComponent :value="tag ?? ''" />
        </div>
        <div class="">
            <p class="">{{ description }}</p>
        </div>
        <div class="gap-lg card-info mt-auto flex justify-start">
            <div>
                <span>Users</span><span>{{ users }}</span>
            </div>
            <div>
                <span>Devices</span><span>{{ props.devices }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import TagComponent from '@/components/ui/tag/TagComponent.vue';
const props = defineProps({
    name: String,
    tag: String,
    description: String,
    users: Number,
    devices: Number,
});
</script>

<style scoped>
@reference '@/assets/styles/default.css';

.card-info div {
    padding: 1rem;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: var(--spacing-sm);
}

p {
    /* TODO: make this into a tailwind utility */
    width: 75%;
    overflow: hidden;
    display: block;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
